/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Payment } from '../models/Payment';
import type { ProcessPaymentInTerminalRequest } from '../models/ProcessPaymentInTerminalRequest';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class PaymentEndpoint {

  constructor(public readonly httpRequest: BaseHttpRequest) {}

  /**
   * @returns Payment
   * @throws ApiError
   */
  public paymentProcessInTerminalCreate({
    id,
    requestBody,
  }: {
    /**
     * A UUID string identifying this payment.
     */
    id: string,
    requestBody: ProcessPaymentInTerminalRequest,
  }): CancelablePromise<Payment> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/payment/{id}/process-in-terminal/',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * @returns Payment
   * @throws ApiError
   */
  public paymentStripeKlarnaCancelRetrieve({
    id,
  }: {
    /**
     * A UUID string identifying this payment.
     */
    id: string,
  }): CancelablePromise<Payment> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/payment/{id}/stripe_klarna_cancel/',
      path: {
        'id': id,
      },
    });
  }

  /**
   * @returns Payment
   * @throws ApiError
   */
  public paymentStripeKlarnaSuccessRetrieve({
    id,
  }: {
    /**
     * A UUID string identifying this payment.
     */
    id: string,
  }): CancelablePromise<Payment> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/payment/{id}/stripe_klarna_success/',
      path: {
        'id': id,
      },
    });
  }

  /**
   * @returns any No response body
   * @throws ApiError
   */
  public paymentConfirmCreate(): CancelablePromise<any> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/payment/confirm/',
    });
  }

}
